import React from "react"
import { Waypoint } from "react-waypoint"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/index/navigation"
import Video from "../components/video"
import TopTitle from "../components/index/top-title"
import TopSearch from "../components/index/top-search"
import Banner from "../components/index/banner"
import NewStore from "../components/index/new-store"
import WhyTakeout from "../components/index/why-takeout"
import WhatsPicks from "../components/index/whats-picks"
import HowToUse from "../components/index/how-to-use"
import UsersVoice from "../components/index/users-voice"
import Over1000Store from "../components/index/over-1000-store"
import Footers from "../components/index/footers"

class IndexPage extends React.Component {
  state = {
    isNavigationTransparent: true,
  }

  handleOnEnterVideo = () => {
    this.setState({ isNavigationTransparent: true })
  }

  handleOnLeaveVideo = () => {
    this.setState({ isNavigationTransparent: false })
  }

  render() {
    return (
      <Layout>
        <SEO />
        <div className="index">
          <Navigation isTransparent={this.state.isNavigationTransparent} />
          <section className="top-video-section">
            <Waypoint
              onEnter={this.handleOnEnterVideo}
              onLeave={this.handleOnLeaveVideo}
              topOffset="100px"
            >
              <div className="video-container">
                <Video
                  videoSrcURL="https://player.vimeo.com/video/339847058/?autoplay=1&loop=1&title=0&byline=0&portrait=0&autopause=0&background=1;"
                  videoTitle="Picks"
                />
                <div className="container is-slim">
                  <div className="is-hidden-tablet">
                    <TopTitle />
                  </div>
                  <div className="is-hidden-mobile">
                    <div>
                      <TopTitle />
                    </div>
                    <div>
                      <TopSearch />
                    </div>
                  </div>
                </div>
              </div>
            </Waypoint>
          </section>
          <section className="is-hidden-tablet">
            <div className="container is-slim">
              <TopSearch />
            </div>
          </section>
          <section>
            <Banner />
          </section>
          <section>
            <NewStore />
          </section>
          <section>
            <WhyTakeout />
          </section>
          <section id="whats-picks">
            <WhatsPicks />
          </section>
          <section>
            <HowToUse />
          </section>
          <section>
            <UsersVoice />
          </section>
          <section>
            <Over1000Store />
          </section>
          <section>
            <Footers />
          </section>
        </div>
      </Layout>
    )
  }
}

export default IndexPage
